import {
	VIEW_BOARD,
	ADMINISTER_BOARD,
	MANAGE_SPRINT,
	BULK_CHANGE,
	CREATE_ISSUE,
	EDIT_ISSUE,
	DELETE_ISSUE,
	ASSIGN_ISSUE,
	TRANSITION_ISSUE,
} from '../constants.tsx';
import type { Permission } from '../types.tsx';

export const getDefaultCompanyManagedPermissions = (): Permission[] => [
	VIEW_BOARD,
	ADMINISTER_BOARD,
	BULK_CHANGE,
	DELETE_ISSUE,
	EDIT_ISSUE,
	CREATE_ISSUE,
	ASSIGN_ISSUE,
	TRANSITION_ISSUE,
	MANAGE_SPRINT,
];
